export default __webpack_public_path__ + "1dc119c3735930243570e204b2300504.png";